import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eungak2r99: FaireBrandEntity = {
  token: "b_eungak2r99",
  type: "brand",
  name: "Nima Accessories Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/1d4870faf9c6df27bc10b3469d1f2b9cbc3be39ba1f1eb7a4f4f8a565eb6d78e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/156a1c406edd3b4813747de5790a5856362e1d8a2991f76fffe1f6891cccb6cc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1d4870faf9c6df27bc10b3469d1f2b9cbc3be39ba1f1eb7a4f4f8a565eb6d78e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/156a1c406edd3b4813747de5790a5856362e1d8a2991f76fffe1f6891cccb6cc.jpeg",
  location: "Cerritos, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 190,
  isInsider: true,
  description:
    'Nima Accessories Inc, has been in the handbag, jewelry and women\'s accessories business since 1982.  Our Administrative office is located in Cerritos, California, complete with a functioning showroom.\n\nNima Accessories Inc. carries the most complete line of ladies accessories ever assembled under one roof.  Nima is your one stop shop for all the latest and most fashion forward ladies accessories in the market.  Come visit our showroom in Cerritos California and see for yourself why we have earned the title of "Your one stop accessory store".  With over 39 different categories in ladies accessories, to include handbags, hats, scarves, fashion jewelry, gift items, belts and many more.\n\nNima Accessories prides itself in offering the newest fashion forward accessories in the market every season.  Look out for our latest collections.',
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:38.788Z",
    importedBy: "entity-db-cli",
  },
};
